export default "__VITE_ASSET__d5a9ef26__"